import { useCallback } from 'react';

import { usePlayerStoreApi } from '@air/component-player';

import { useVideoTimestampObserverContext } from '~/providers/VideoTimestampObserverProvider';

export const useCurrentPlayerTimeGetter = () => {
  const playerStore = usePlayerStoreApi();
  const { getCurrentTime } = useVideoTimestampObserverContext();

  const getCurrentPlayerTime = useCallback(() => {
    const state = playerStore.getState();
    const observedCurrentTime = getCurrentTime();

    return state.videoElement?.currentTime ?? observedCurrentTime ?? state.currentTime ?? 0;
  }, [getCurrentTime, playerStore]);

  return { getCurrentPlayerTime };
};
